<template>
    <modal name="item-filter-holding-filter" class="filter-modal item-filter-holding-filter"
           :width="`100%`" :height="`auto`" :pivotY="0.5"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div>
            <div class="filter_modal_wrap">
                <div class="filter_modal_top">
                    <div class="filter_img"></div>
                    <div class="filter_name">{{ $t('filter') }}</div>
                    <div class="close_btn" @click="modalClose()"></div>
                </div>

                <div class="mt20 filter_modal_status">
                    <div class="modal_title">{{ $t('category') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterCategory"
                                               @change="setFilterFunc('ic', filterCategory)">
                                <el-checkbox :label="2">{{ $t('art') }}</el-checkbox>
                                <el-checkbox :label="178">{{ $t('prompt') }}</el-checkbox>
                                <el-checkbox :label="9">{{ $t('collections') }}</el-checkbox>
                                <el-checkbox :label="3">{{ $t('picture') }}</el-checkbox>
                                <el-checkbox :label="5">{{ $t('music') }}</el-checkbox>
<!--                                <el-checkbox :label="4">{{ $t('video') }}</el-checkbox>-->
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>



                <div class="mt20 filter_modal_edition">
                    <div class="modal_title">{{ $t('edition') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterEdition"
                                               @change="setFilterFunc('ed', filterEdition)">
                                <el-checkbox :label="1">{{ $t('edition') }}</el-checkbox>
                                <el-checkbox :label="0"> {{ $t('single') }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>

                <div class="mt20 filter_modal_type">
                    <div class="modal_title">{{ $t('type') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterType"
                                               @change="setFilterFunc('ty', filterType)">
                                <el-checkbox :label="'digital'">{{ $t('digital') }}</el-checkbox>
                                <el-checkbox :label="'real'">{{ $t('real') }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>

                <div class="mt20 filter_modal_edition">
                    <div class="modal_title">{{ $t('status') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterStatus"
                                               @change="  setFilterFunc('imst', filterStatus)">
                                <el-checkbox :label="'auction'">
                                    {{ $t('auction') }}
                                </el-checkbox>
                                <el-checkbox :label="'license'">
                                    {{ $t('license_sell') }}
                                </el-checkbox>
                                <el-checkbox :label="'fix'">
                                    {{ $t('fix_selling') }}
                                </el-checkbox>
                                <el-checkbox :label="'no'">
                                    {{ $t('no_sell') }}
                                </el-checkbox>
                                <el-checkbox :label="'competition'">
                                    {{ $t('competition_apply') }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>

                <div class="mt20 filter_modal_edition">
                    <div class="modal_title">{{ $t('c_request') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterCuration"
                                               @change="setFilterFunc('iscu', filterCuration)">
                                <el-checkbox :label="1"> {{ $t('apply1') }}</el-checkbox>
                                <el-checkbox :label="2"> {{ $t('not_apply') }}</el-checkbox>

                            </el-checkbox-group>
                        </div>
                    </div>
                </div>

                <div class="wrapper_bottom">
                    <button class="" @click="modalClose">{{ $t('apply2') }}</button>
                </div>

            </div>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";
import itemUtil from "@/components/item/itemUtil";

const {filterConfig} = itemUtil

export default {
    name: "ItemFilterHoldingFilter",
    mixins: [],
    components: {},
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        modalLayout: '',
    },
    data() {
        return {
            sortData: {},
            filterData: {},
            searchInputOption: 'ina',
            filterCategory: [],
            filterStatus: [],
            filterEdition: [],
            filterType: [],
            priceInput: ['', ''],
            filterCuration: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            console.log(event)
            if(!util.isEmpty(event.params.filterData)) {
                this.filterData = event.params.filterData;
            }
            this.setterFilterDataInData();
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        modalClose() {
            this.$modal.hide('item-filter-holding-filter');
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },

        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
